module.exports = __webpack_public_path__ + "mobile/img/home-img1.25ff63cc.png";